












import Vue from 'vue';

interface Option {
  label: string;
  value: { enum: string, k1: number, k2: number };
}

export default Vue.extend({
  name: "CSelect",
  props: {
    value: { type: [String, Number, Object] } as any,
    options: { type: Array, required: true } as any,
    searchable: { type: Boolean, default: false } as any,
    disabled: { type: Boolean, default: false },
  },

  data() {
    return {
      loading: false,
      // @ts-ignore
      selectedOption: this.initialValue as any
    };
  },

  mounted(){
    this.selectedOption = this.initialValue
  },

  methods: {
    handleChange(value: string | number | object) {
      const mappedOption: Option = (this.options as any[]).find((option) => option.value.enum === value)
      this.selectedOption = value
      return this.$emit('input', mappedOption);
    },

    toggleLoading(status: boolean) {
      // @ts-ignore
      this.loading = status;
    },

    filterOption(input: string, option: any) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  },

  computed: {
    initialValue(): string | unknown {
      if (this.value && (this.value as Option).value) {
        return (this.value as Option).value.enum
      }

      return this.value
    },

    mappedOptions(): Option[] {
      return (this.options as Option[]).map((option: any) => ({ label: option.label, value: option.value.enum }))
    }
  },

  watch: {
    value(newValue) {
      console.log(newValue, "newValue")
      if (newValue && newValue.value) {
        this.selectedOption = (newValue as Option).value.enum
      } else {
        this.selectedOption = newValue
      }
    }
  },

});
